/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumUserType = "doctor" | "guest" | "patient" | "staff" | "system" | "%future added value";
export type ActionsPatient_EmbedViewer = {
    readonly type: EnumUserType | null;
    readonly user: {
        readonly setting: {
            readonly settings: {
                readonly telehealth: {
                    readonly enabled: boolean | null;
                } | null;
            } | null;
        } | null;
    } | null;
    readonly setting: {
        readonly settings: {
            readonly telehealth: {
                readonly enabled: boolean | null;
            } | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"IconButtonPatientActions_EmbedViewer">;
    readonly " $refType": "ActionsPatient_EmbedViewer";
};
export type ActionsPatient_EmbedViewer$data = ActionsPatient_EmbedViewer;
export type ActionsPatient_EmbedViewer$key = {
    readonly " $data"?: ActionsPatient_EmbedViewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ActionsPatient_EmbedViewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Setting",
  "kind": "LinkedField",
  "name": "setting",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SettingSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SettingSettingsTelehealth",
          "kind": "LinkedField",
          "name": "telehealth",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enabled",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionsPatient_EmbedViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IconButtonPatientActions_EmbedViewer"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();
(node as any).hash = 'cfd64ffaacf33b57457bed41d83c5d2b';
export default node;
